<template>
  <div>
    <div
      v-if="
        (products && products.length > 0) ||
        (subCategories && subCategories.length > 0)
      "
    >
      <div style="width: 100%" v-if="subCategories && subCategories.length > 0">
        <vs-col
          style="padding: 0"
          class="mb-10"
          v-for="subCategory in subCategories"
          :key="subCategory.id"
        >
          <div class="row">
            <h5>{{ subCategory.title }}</h5>
            <div class="flex ml-3">
              <vs-button
                @click="editSubCategory(subCategory)"
                class="flex-1 mr-1"
                color="primary"
                type="filled"
                size="small"
                icon-pack="feather"
                icon="icon-edit"
              />
              <vs-button
                @click="removeSubCategory(subCategory)"
                class="flex-1 ml-1"
                color="danger"
                type="filled"
                size="small"
                icon-pack="feather"
                icon="icon-trash"
              />
            </div>
          </div>
          <vs-col
            class="products-cont"
            v-for="product in subCategory.items"
            :key="product.id"
            style="float: right"
            vs-lg="2"
            vs-sm="3"
            vs-xs="4"
          >
            <product
              :product="product"
              :categories="categories"
              :activeCategory="activeCategory"
              :activeSubCategory="subCategory"
              @delete="$emit('delete', product, subCategory)"
              @productCategoryChanged="productCategoryChanged"
            ></product>
          </vs-col>
        </vs-col>
      </div>
      <template style="width: 100%" v-if="products && products.length > 0">
        <vs-col
          class="products-cont"
          v-for="product in products"
          :key="product.id"
          style="float: right"
          vs-lg="2"
          vs-sm="3"
          vs-xs="4"
        >
          <product
            :product="product"
            :categories="categories"
            :activeCategory="activeCategory"
            @delete="$emit('delete', product)"
            @productCategoryChanged="productCategoryChanged"
          ></product>
        </vs-col>
      </template>

      <vs-popup
        v-if="showEditSubCategoryPopup"
        title="ویرایش زیر دسته"
        :active.sync="showEditSubCategoryPopup"
      >
        <sub-category-input
          v-model="activeSubCategory"
          :categories="categories || []"
          @close="showEditSubCategoryPopup = false"
          :activeCategory="activeCategory"
          @subCategoryUpdated="subCategoryUpdated"
        ></sub-category-input>
      </vs-popup>
    </div>
    <vs-alert v-else color="warning" icon-pack="feather" icon="icon-info">
      محصولی جهت نمایش موجود نیست
    </vs-alert>
  </div>
</template>

<script>
import Product from "./Product.vue";
import SubCategoryInput from "../SubCategoryInput.vue";
import productApiService from "../../../services/api/ProductApiService";
import { mapGetters } from "vuex";

export default {
  name: "Products",
  components: { Product, SubCategoryInput },
  data() {
    return {
      showEditSubCategoryPopup: false,
      activeSubCategory: null,
      products: this.activeCategory ? this.activeCategory.items : null,
      subCategories: this.activeCategory
        ? this.activeCategory.subCategories
        : null,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    subCategoryUpdated(resource, category) {
      if (category.id === this.activeCategory.id) {
        const currentSubCategoryIndex = this.subCategories.findIndex(
          (element) => element.id === resource.id
        );

        this.subCategories[currentSubCategoryIndex].items = this.subCategories[
          currentSubCategoryIndex
        ].items.map((element) => {
          return {
            ...element,
            available: +resource.available ? true : false,
          };
        });
        this.subCategories[currentSubCategoryIndex].title = resource.title;
        this.subCategories[currentSubCategoryIndex].thumbnail =
          resource.thumbnail;
        this.subCategories[currentSubCategoryIndex].level = resource.level;
        this.subCategories[currentSubCategoryIndex].visible = +resource.visible;
        this.subCategories[currentSubCategoryIndex].available =
          +resource.available;
        this.subCategories[currentSubCategoryIndex].description =
          resource.description;
      } else {
        this.$emit(
          "subCategoryChanged",
          resource,
          category,
          this.activeSubCategory
        );
      }
    },
    productCategoryChanged(resource, category, subCategory) {
      this.$emit("productCategoryChanged", resource, category, subCategory);
    },
    editSubCategory(subCategory) {
      this.activeSubCategory = subCategory;
      this.showEditSubCategoryPopup = true;
    },
    removeSubCategory(subCategory) {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `حذف زیر دسته`,
        text: `از حذف زیر دسته "${subCategory.title}" اطمینان دارید؟\n تمامی محصولات در این زیردسته نیز حذف خواهند شد.`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$vs.loading();
          productApiService
            .deleteCategory(this.currentProvider.id, subCategory.id)
            .then(() => {
              this.subCategories = this.subCategories.filter(
                (item) => item.id !== subCategory.id
              );

              this.$vs.notify({
                text: "زیر دسته با موفقیت حذف شد",
                color: "success",
                position: "bottom-center",
              });
            })
            .catch((err) => {
              this.$vs.notify({
                text: err.getErrorDescriptions(),
                color: "danger",
                position: "bottom-center",
              });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        },
      });
    },
  },
  watch: {
    activeCategory(category) {
      this.products = category ? category.items : null;
      this.subCategories = category ? category.subCategories : null;
    },
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    activeCategory: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.products-cont {
  padding: 0;
  margin-bottom: 0;
  float: left !important;
  position: relative;

  @media (max-width: 350px) {
    width: 50% !important;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    width: 25% !important;
  }

  @media (min-width: 1100px) and (max-width: 1200px) {
    width: 12.5% !important;
  }

  @media (min-width: 1400px) {
    width: 12.5% !important;
  }
}

.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
}
</style>
